import { ref } from "vue";

const ReturnTypeComponent = {
	props: {
		type: String,
		title: String,
		selected: Boolean,
		buttonSubtext: String,
	},
	emits: [
		'selected',
	],
	setup( props, { emit } ) {
		const title = props.title;
		const buttonSubtext = props.buttonSubtext;
		const selected = props.selected;
		const submit = () => emit( 'selected' );
		return {
			title,
			selected,
			buttonSubtext,
			submit,
		};
	},
	template: `
	<form @submit.prevent="submit" class="return-type p-4 border flex-grow" :class="{ selected }">
		<div class="uppercase font-bold text-lg">
			{{ title }}
		</div>
		<div class="return-type--body">
			<slot />
		</div>
		<div class="flex flex-col justify-center items-center">
			<button type="submit" class="button button--primary">
				Seleziona questa modalità
			</button>
		</div>
	</form>
	`
}

const ReturnsWizardTypeSelectionComponent = {
	props: {
		selected: String
	},
	emits: [
		'typeSelected'
	],
	setup( props, { emit } ) {

		// If we arrive at this step with a returnType preselected, highlight it.
		const selected = ref( props.selected ?? '' );

		// When the user selects a type, emit the typeSelectd event.
		const submit = v => emit( 'typeSelected', v );

		return {
			selected,
			submit,
		}
	},
	template: `
		<div class="wizard-step-body">
			<div class="return-type--container">

				<ReturnTypeComponent :selected="selected === 'STORE'" @selected="submit('STORE')" type="STORE" title="Gratuito in negozio">
					<p>Riconsegna gratuitamente il tuo ordine nel negozio selezionato in fase di reso.</p>
					<p>Il negozio si occuperà di farci pervenire il tuo reso al nostro magazzino centrale, dove verificheremo la conformità del reso ed effettueremo il rimborso.</p>
					<p>Il negozio è autorizzato al ritiro della merce solamente dopo la corretta apertura del reso sul sito.</p>
				</ReturnTypeComponent>

				<ReturnTypeComponent :selected="selected === 'HOME'" @selected="submit('HOME')" type="HOME" title="Ritiro a domicilio">
					<p>Puoi richiedere che sia DF Sport Specialist ad inviarti il suo corriere per il ritiro del prodotto, le spese di trasporto saranno a tuo carico.</p>
					<p>Il costo di questo servizio è di 8€, che verranno trattenuti dal rimborso della merce resa. In caso di reso di biciclette il costo del servizio è di 20€, per le e-bike e macchine da palestra è di 40€.</p>
				</ReturnTypeComponent>

				<ReturnTypeComponent :selected="selected === 'SELFSERVICE'" @selected="submit('SELFSERVICE')" type="SELFSERVICE"  title="Spedizione autonoma">
					<p>Puoi utilizzare direttamente un corriere di fiducia o recarti presso un ufficio postale per la spedizione.</p>
					<p>Scegli la procedura di spedizione autonoma e completa la richiesta di reso prima di affidare il pacco al vettore scelto.</p>
					<p>Le spese di spedizione saranno a tuo carico.</p>
				</ReturnTypeComponent>

			</div>
		</div>
	`,
	components: {
		ReturnTypeComponent,
	}
}

export default ReturnsWizardTypeSelectionComponent;
